import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Grid, MenuItem, Select, FormControl, InputLabel, Divider } from "@mui/material";
import { Add, CheckCircle, Download } from '@mui/icons-material';
import apiService from "../../service/apiService";
import { FaListAlt, FaArrowRight, FaMap, FaCrop, FaUsers, FaEye, FaRegEdit, FaTrash, FaPlus, FaRupeeSign } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import '../../assets/styles/cropmanage.css';
import * as XLSX from "xlsx";
import UploadIcon from '@mui/icons-material/Upload';
import { Pagination } from "react-bootstrap";
import { format, parseISO } from "date-fns";
import { debounce } from "lodash";
import { FaSeedling } from "react-icons/fa6";
import { GiProfit } from "react-icons/gi";

const Farmerdata = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Essential state variables only
  const [openEdit, setOpenEdit] = useState(false);
  const [pageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [newState, setNewState] = useState({ seasonId: null, yearId: null, farmerId: null });
  const [seasons, setSeasons] = useState([]);
  const [years, setYears] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [farmerName, setFarmerName] = useState('');
  const [seeds, setSeeds] = useState([]);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [farName, setFarName] = useState("");
  const [gendid, setGendId] = useState(0);
  const [genders, setGenders] = useState([]);
  const [castid, setCastId] = useState(0);
  const [sesid, setSesId] = useState(location.state?.season || 0);
  const [pgcode, setPgCode] = useState("");
  const [totalProduction, setTotalProduction] = useState(null);
  const [cultivatedArea, setCultivatedArea] = useState(null);
  const [totaladitionalincome, setTotaladitionalincome] = useState(null);
  const [castes, setCastes] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [cropPlans, setCropPlans] = useState([]);
  const [seedVarietyId, setSeedVarietyId] = useState('');
  const [seedVarieties, setSeedVarieties] = useState([]);
  const [seedClassId, setSeedClassId] = useState('');
  const [seedClasses, setSeedClasses] = useState([]);
  const [cropTypes, setCropTypes] = useState([]);
  const [cropPlanMasterId, setCropPlanMasterId] = useState("");
  const [seedId, setSeedId] = useState("");
  const [cropTypeId, setCropTypeId] = useState("");
  const [area, setArea] = useState("");
  const [leasearea, setLeaseArea] = useState("");
  const [quantity, setQuantity] = useState("");
  const [openAddPlan, setOpenAddPlan] = useState(false);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [carddata, setCardData] = useState([]);
  const [alldata, setAllData] = useState([]);
  const [year, setYear] = useState(location.state?.year || null);
  const [showBreakupfarmer, setShowBreakupfarmer] = useState(false);
  const [showBreakupplan, setShowBreakupplan] = useState(false);
  const [crops, setCrops] = useState([]);
  const [farmersData, setFarmersData] = useState([]);
  const [farmerArea, setfarmerArea] = useState([]);
  const [totalsellPrice, setTotalSellPrice] = useState([]);
  const [totalbasePrice, setTotalBasePrice] = useState([]);
  const [planmstrid, setPlanmstrId] = useState(null);
  const [isLeaseArea, setIsLeaseArea] = useState(false);
  const [selectedFarmerid, setSelectedFarmerId] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [availablearea, setAvailableArea] = useState(0);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [seasonName, setSeasonName] = useState("");

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(
    loginData?.districtId !== null && loginData?.districtId !== undefined
      ? loginData.districtId
      : (location.state?.dist && location.state.dist !== 0 ? location.state.dist : 0)
  );
  const [blk, setBlk] = useState(
    loginData?.blockId !== null && loginData?.blockId !== undefined
      ? loginData.blockId
      : (location.state?.blk && location.state.blk !== 0 ? location.state.blk : 0)
  );

  const handleSelectRow = (id, isVerified) => {
    if (isVerified) return;
    setSelectedRows((prev) => {
      const newSelectedRows = prev.includes(id)
        ? prev.filter((rowId) => rowId !== id)
        : [...prev, id];
      setSelectAll(newSelectedRows.length === alldata.filter((data) => !data.isVerified).length);
      return newSelectedRows;
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const selectableIds = alldata.filter((data) => !data.isVerified).map((data) => data.marketLinkageMasterId);
      setSelectedRows(selectableIds);
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    const loadDistricts = async () => {
      try {
        const res = await apiService.get("/districts/get-all");
        if (res.data) {
          setDistricts(res.data);
        }
      } catch (err) {
        console.error("Error fetching districts:", err);
      }
    };
    loadDistricts();
  }, []);

  const toggleBreakupFarmer = () => {
    setShowBreakupfarmer(!showBreakupfarmer);
  };

  const fetchData = async () => {
    try {
      const payload = {
        pageNumber: page,
        pageSize: pageSize,
        villageId: 0,
        farmerId: 0,
        seasonId: 0,
        producerGroupId: 0,
        farmerName: farmerName || undefined,
        pgCode: pgcode || undefined,
        seasonName: seasonName || undefined,
        totalProduction: totalProduction ? Number(totalProduction) : undefined,
        cultivatedArea: cultivatedArea ? Number(cultivatedArea) : undefined,
        totaladitionalincome: totaladitionalincome ? Number(totaladitionalincome) : undefined,
        year: year ? parseInt(year, 10) : null,
        districtId: dist,
        blockId: blk
      };

      const response = await apiService.post("/market-linkage/get-market-linkage-index", payload);

      if (response.data.status) {
        const formattedData = response.data.body.data.map((item) => ({
          id: item.cropProductionMasterId,
          cropProductionMasterId: item.cropProductionMasterId,
          plannedArea: item.plannedArea,
          totalProduction: item.totalProduction,
          cultivatedArea: item.cultivatedArea,
          seasonName: item.seasonName,
          cropPlanMasterId: item.cropPlanMasterId,
          villageName: item.villageName,
          marketLinkageMasterId: item.marketLinkageMasterId,
          farmerName: item.farmerName,
          pgName: item.pgName,
          pgCode: item.pgCode,
          totalAdditionalIncome: item.totalAdditionalIncome,
          isVerified: item.isVerified
        }));

        setAllData(formattedData);
        setTotalitems(response.data.body.recordsCount);
        setTotalpage(response.data.body.pageCount);
        setRows(formattedData);
      } else {
        setTotalitems(0);
        setTotalpage(0);
        setAllData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
      setTotalitems(0);
      setTotalpage(0);
    }
  };

  const debouncedFetchData = useCallback(debounce(fetchData, 500), [
    farmerName, pgcode, seasonName, totalProduction, cultivatedArea, totaladitionalincome,
    page, pageSize, year, blk, dist
  ]);

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData]);

  const fetchCardData = async () => {
    try {
      const response = await apiService.post(`/dashboard/market-linkage`, {
        seasonId: selectedSeasonId,
        year: year,
        districtId: dist,
        blockId: blk
      });
      setCardData(response.data.body);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  const fetchgraphData = async () => {
    try {
      const response = await apiService.post(`/dashboard/market-linkage-graph`, {
        seasonId: selectedSeasonId,
        year: year,
        districtId: dist,
        blockId: blk
      });

      const body = response.data?.body;
      if (!response.data?.status || !response.data?.body) {
        setCrops([]);
        setTotalSellPrice([]);
        setTotalBasePrice([]);
        return;
      }

      const crops = Object.keys(body).filter(key => key !== 'Season');
      setCrops(crops);
      const totalSalePrice = crops.map(crop => body[crop]?.totalSalePrice || 0);
      setTotalSellPrice(totalSalePrice);
      const totalBasePrice = crops.map(crop => body[crop]?.totalBasePrice || 0);
      setTotalBasePrice(totalBasePrice);
    } catch (error) {
      console.error("Error fetching graph data:", error);
    }
  };

  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
      const currentSes = location.state?.season;
      const defaultSes = response.data.find((ses) => ses.seasonId === currentSes);
      setSeasonName(defaultSes ? defaultSes.seasonName : "");
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);
      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };

  useEffect(() => {
    fetchSeasons();
    fetchYears();
  }, []);

  useEffect(() => {
    if (selectedSeasonId !== null && year !== null) {
      fetchCardData();
      fetchgraphData();
    }
  }, [selectedSeasonId, year, dist, blk]);

  // Chart configuration
  const getColumnWidth = () => {
    const numCrops = crops.length;
    if (numCrops <= 1) return "5%";
    else if (numCrops <= 4) return "10%";
    else return "30%";
  };

  const chartOptions = {
    chart: { type: "bar", toolbar: { show: true } },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: getColumnWidth(),
        borderRadius: 5,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: crops,
      title: { text: "Crops", style: { fontSize: "14px", fontWeight: "bold" } },
    },
    yaxis: {
      title: { text: "Price", style: { fontSize: "14px", fontWeight: "bold" } },
    },
    colors: ["#00773E", "#ee781c"],
    legend: { position: "bottom", horizontalAlign: "center" },
    grid: { borderColor: "#e7e7e7", strokeDashArray: 5 },
  };

  const chartSeries = [
    { name: "Total Base Price", data: totalbasePrice },
    { name: "Total Sell price", data: totalsellPrice },
  ];

  // Event handlers
  const handleView = (data) => {
    navigate("/childmarket", { state: { marketLinkageMasterId: data.marketLinkageMasterId, isVerified: data.isVerified } });
  };

  const handleDelete = (id) => {
    setSelectedRow(alldata.find((row) => row.marketLinkageMasterId === id));
    setOpenDelete(true);
  };

  const handleDeleteRow = async () => {
    try {
      const { marketLinkageMasterId } = selectedRow;
      await apiService.delete(`/market-linkage/${marketLinkageMasterId}`);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      setOpenDelete(false);
    }
  };

  const handleVerify = async () => {
    const isConfirmed = window.confirm("Are you sure you want to verify the selected Market Linkage?");
    if (!isConfirmed) return;

    try {
      const response = await apiService.put('/market-linkage/verify', {
        marketLinkageMasterIds: selectedRows,
        remarks: "Verified successfully"
      });

      if (response.status === 200) {
        alert("Verification successful!");
        setSelectedRows([]);
        fetchData();
      }
    } catch (error) {
      alert("Error verifying records: " + error.message);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }

    return paginationItems;
  };

  const exportToExcel = async () => {
    const headers = [
      ["Farmer Name", "Season", "PG Code", "Cultivated Area (ha)", "Production (q)", "Additional Income (₹)", "Status"]
    ];

    const payload = {
      "pageNumber": 1, "pageSize": 1000000000, "villageId": 0, "farmerId": 0,
      "seasonId": 0, "producerGroupId": 0, "farmerName": "", "pgCode": "",
      "seasonName": "", "totalProduction": null, "cultivatedArea": null,
      "totaladitionalincome": null, "year": year, "districtId": dist, "blockId": blk
    };

    try {
      const response = await apiService.post("/market-linkage/get-market-linkage-index", payload);

      if (response && response.data && response.data.body && response.data.body.data) {
        const marketLinkageData = response.data.body.data;
        const dataRows = marketLinkageData.map(data => [
          data.farmerName, data.seasonName, data.pgCode, data.cultivatedArea,
          data.totalProduction, data.totalAdditionalIncome,
          data.isVerified ? "Verified" : "Not Verified"
        ]);

        const worksheetData = [...headers, ...dataRows];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Market Linkage");
        XLSX.writeFile(workbook, `Market_Linkage_Data_${year}.xlsx`);
      }
    } catch (error) {
      console.error("Error fetching data or exporting to Excel:", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  return (
    <Box m="2px">
      <div style={{ maxHeight: "100vh", overflowY: "auto" }}>
        {/* Header - Same design as cropmanage */}
        <div style={{
          backgroundColor: "#ffffff",
          borderBottom: "3px solid #007bff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}>
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center py-3 px-4">
              <div className="d-flex align-items-center">
                <div>
                  <h1 style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    color: "#2c3e50",
                    margin: "0"
                  }}>
                    Market Linkage
                  </h1>
                </div>
              </div>

              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center">
                  <label style={{
                    fontWeight: "500",
                    color: "#495057",
                    marginRight: "10px",
                    fontSize: "14px"
                  }}>
                    Year:
                  </label>
                  <select
                    className="form-select"
                    value={year || 0}
                    onChange={(e) => setYear(Number(e.target.value))}
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      minWidth: "100px",
                      backgroundColor: "#fff"
                    }}
                  >
                    <option value={0} disabled>Select Year</option>
                    {years.map((yr) => (
                      <option key={yr.yearId} value={yr.yearValue}>
                        {yr.yearValue}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <Button
                    variant="contained"
                    onClick={exportToExcel}
                    style={{
                      backgroundColor: "#007bff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      fontWeight: "500",
                      textTransform: "none"
                    }}
                  >
                    Export Excel
                  </Button>
                  
                  {/* <Button
                    variant="contained"
                    onClick={handleVerify}
                    disabled={selectedRows.length === 0}
                    style={{
                      backgroundColor: "#00796b",
                      border: "none",
                      borderRadius: "6px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      fontWeight: "500",
                      textTransform: "none",
                      opacity: selectedRows.length === 0 ? 0.6 : 1
                    }}
                  >
                    Verify
                  </Button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Table Section - Same design as cropmanage */}
        <div className="mx-2" style={{ minHeight: "75vh", overflowY: "auto", overflowX: "auto", maxWidth: "100%", whiteSpace: "nowrap" }}>
          <table className="table table-hover mb-0" style={{
            minWidth: "1200px",
            backgroundColor: "#fff"
          }}>
            <thead style={{
              backgroundColor: "#007bff",
              color: "white",
              position: "sticky",
              top: "0",
              zIndex: "10"
            }}>
              <tr>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  textAlign: "center",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "60px"
                }}>
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectAll && selectedRows.length > 0}
                    style={{ transform: "scale(1.2)" }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "150px"
                }}>
                  Farmer Name
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={farmerName}
                    onChange={(e) => { setFarmerName(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px"
                }}>
                  Season
                  <br />
                  <select
                    value={seasonName}
                    onChange={(e) => { setSeasonName(e.target.value); setPage(1); }}
                    className="form-control form-control-sm mt-2"
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  >
                    <option value="">Select All</option>
                    {seasons.map((ses) => (
                      <option key={ses.seasonId} value={ses.seasonName}>
                        {ses.seasonName}
                      </option>
                    ))}
                  </select>
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "120px"
                }}>
                  PG Code
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={pgcode}
                    onChange={(e) => { setPgCode(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "120px"
                }}>
                  Cultivated Area (ha)
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={cultivatedArea}
                    onChange={(e) => { setCultivatedArea(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "120px"
                }}>
                  Production (q)
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={totalProduction}
                    onChange={(e) => { setTotalProduction(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "140px"
                }}>
                  Additional Income (₹)
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={totaladitionalincome}
                    onChange={(e) => { setTotaladitionalincome(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px",
                  textAlign: "center"
                }}>
                  Status
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  textAlign: "center",
                  minWidth: "100px"
                }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody style={{ fontSize: "13px" }}>
              {alldata.map((data, index) => (
                <tr key={index} style={{
                  backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                  borderBottom: "1px solid #dee2e6"
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e3f2fd";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
                  }}>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(data.marketLinkageMasterId)}
                      onChange={() => handleSelectRow(data.marketLinkageMasterId, data.isVerified)}
                      disabled={data.isVerified}
                      style={{ transform: "scale(1.2)" }}
                    />
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6",
                    fontWeight: "500"
                  }}>
                    {data.farmerName}
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: data.seasonName === 'Rabi' ? '#d4edda' : '#fff3cd',
                      color: data.seasonName === 'Rabi' ? '#155724' : '#856404',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "11px",
                      fontWeight: "500"
                    }}>
                      {data.seasonName}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    {data.pgCode}
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: '#007bff',
                      color: 'white',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                      {data.cultivatedArea}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: '#28a745',
                      color: 'white',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                      {data.totalProduction}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: '#ffc107',
                      color: '#212529',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                      ₹{data.totalAdditionalIncome}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      color: data.isVerified ? "#28a745" : "#dc3545",
                      fontWeight: "600",
                      fontSize: "12px"
                    }}>
                      {data.isVerified ? "Verified" : "Not Verified"}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center"
                  }}>
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() => handleView(data)}
                      title="View"
                      style={{
                        padding: "4px 8px",
                        fontSize: "12px"
                      }}
                    >
                      <FaEye />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, totalItems)} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>

        {/* Add Dialog */}
        <Dialog open={openAdd} onClose={() => setOpenAdd(false)}>
          <DialogTitle>Add Market Linkage</DialogTitle>
          <DialogContent>
            <TextField
              label="Farmer Name"
              value={newState.farmerName || ''}
              onChange={(e) => setNewState({ ...newState, farmerName: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="PG Code"
              value={newState.pgCode || ''}
              onChange={(e) => setNewState({ ...newState, pgCode: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Season"
              value={newState.season || ''}
              onChange={(e) => setNewState({ ...newState, season: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Cultivated Area"
              value={newState.cultivatedArea || ''}
              onChange={(e) => setNewState({ ...newState, cultivatedArea: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Total Production"
              value={newState.totalProduction || ''}
              onChange={(e) => setNewState({ ...newState, totalProduction: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Additional Income"
              value={newState.additionalIncome || ''}
              onChange={(e) => setNewState({ ...newState, additionalIncome: e.target.value })}
              fullWidth
              margin="normal"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAdd(false)} color="primary">Cancel</Button>
            <Button onClick={() => setOpenAdd(false)} color="primary">Save</Button>
          </DialogActions>
        </Dialog>

        {/* Delete Dialog */}
        <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this market linkage record?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDelete(false)} color="primary">Cancel</Button>
            <Button onClick={handleDeleteRow} color="primary">Delete</Button>
          </DialogActions>
        </Dialog>
      </div>
    </Box>
  );
};

export default Farmerdata;